module.exports = __webpack_public_path__ + "img/logo-small.a0fca85.png";